import usePostApi from '@/composables/post/postApi'
import { Post } from '@/model/data-object/Post'
import usePostList, { PostsRoot } from '@/composables/post/postList'

const parents: Map<string, Post> = new Map([])
const missingParentStack: PostsRoot[][] = []

export default function usePostParentManager() {
  const { findPostRoot, postList } = usePostList()

  async function loadMissingParents() {
    const ids = Object.keys(missingParentStack)
    const { fetchByIds } = usePostApi()
    const { response, request } = fetchByIds(ids)
    await request()

    if (response.value) {
      response.value.map(post => {
        parents.set(post.id.toString(), post as Post)
      })
    }
  }

  const findPostParent = (id: string) => {
    if (parents.has(id)) {
      return parents.get(id)
    }
  }

  function assignMissingParents() {
    for (const [parentId, posts] of Object.entries(missingParentStack)) {
      const parentPost = findPostParent(parentId)

      for (const [key, post] of Object.entries(posts)) {
        if (typeof parentPost !== 'undefined') {
          post.parentPost = parentPost
        }
      }
    }
    missingParentStack.length = 0
  }

  async function resolveMissingParentStack() {
    if (missingParentStack.length > 0) {
      await loadMissingParents()
      assignMissingParents()
    }
  }

  const resolvePostParents = (posts: PostsRoot[]) => {
    posts.forEach((post: PostsRoot) => {
      if (post.post && post.post.parent) {
        if (post.parentPost) {
          return
        }
        const parentPostRoot = findPostRoot(post.post.parent)
        if (parentPostRoot) {
          post.parentPost = parentPostRoot.post
          return
        }
        if (!(post.post.parent in missingParentStack)) {
          missingParentStack[post.post.parent] = []
        }

        missingParentStack[post.post.parent].push(post)
      }
    })
  }

  return {
    resolvePostParents,
    resolveMissingParentStack,
  }
}
